import { defineMessages } from 'react-intl';

import { StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';
import { UploadSessionStatus } from '@/shared/api/protocol-ts/model/dto_upload_session_pb';

export const studyCardTitle = defineMessages<StudyType>({
  [StudyType.StudyType_CBCT]: {
    id: 'studyCardTitle.studyTypeCBCT',
    defaultMessage: 'CBCT',
  },
  [StudyType.StudyType_PanoramicXRay]: {
    id: 'studyCardTitle.studyTypePanoramicXRay',
    defaultMessage: 'PANO',
  },
  [StudyType.StudyType_IntraoralXRay]: {
    id: 'studyCardTitle.studyTypeIntraoralXRay',
    defaultMessage: 'IOXRay',
  },
  [StudyType.StudyType_DentalPhoto]: {
    id: 'studyCardTitle.studyTypeDentalPhoto',
    defaultMessage: 'Dental Photo',
  },
  [StudyType.StudyType_IOS_Meshes]: {
    id: 'studyCardTitle.studyTypeIOSMeshes',
    defaultMessage: 'Intraoral Scan',
  },
  [StudyType.StudyType_InvalidValue]: {
    id: 'studyCardTitle.studyTypeInvalidValue',
    defaultMessage: 'InvalidValue',
  },
});

export const orderReportButtonMessages = defineMessages<StudyType>({
  [StudyType.StudyType_CBCT]: {
    id: 'studyCard.orderReportButton.studyTypeCBCT',
    defaultMessage: 'Create CBCT AI report',
  },
  [StudyType.StudyType_PanoramicXRay]: {
    id: 'studyCard.orderReportButton.studyTypePanoramicXRay',
    defaultMessage: 'Create PANO AI report',
  },
  [StudyType.StudyType_IntraoralXRay]: {
    id: 'studyCard.orderReportButton.studyTypeIntraoralXRay',
    defaultMessage: 'Create IOXRay AI report',
  },
  [StudyType.StudyType_DentalPhoto]: {
    id: 'studyCard.orderReportButton.studyTypeDentalPhoto',
    defaultMessage: 'Create Dental Photo report',
  },
  [StudyType.StudyType_IOS_Meshes]: {
    id: 'studyCard.orderReportButton.studyTypeIOSMeshes',
    defaultMessage: 'Create Intraoral Scan report',
  },
  [StudyType.StudyType_InvalidValue]: {
    id: 'studyCard.orderReportButton.studyTypeInvalidValue',
    defaultMessage: 'InvalidValue',
  },
});

export const studyCardUploadingStatusMessage =
  defineMessages<UploadSessionStatus>({
    [UploadSessionStatus.UploadSessionStatusInProgress]: {
      id: 'studyCard.uploadingStatusMessage.studyStatusUploading',
      defaultMessage: 'Uploading',
    },
    [UploadSessionStatus.UploadSessionStatusSuccessful]: {
      id: 'studyCard.uploadingStatusMessage.studyStatusFinished',
      defaultMessage: 'Upload successful',
    },
    [UploadSessionStatus.UploadSessionStatusFailed]: {
      id: 'studyCard.uploadingStatusMessage.studyStatusFailed',
      defaultMessage: 'Upload error',
    },
    [UploadSessionStatus.UploadSessionStatusCancelled]: {
      id: 'studyCard.uploadingStatusMessage.studyStatusInvalidValue',
      defaultMessage: 'Invalid value',
    },
    [UploadSessionStatus.UploadSessionStatusClosing]: {
      id: 'studyCard.uploadingStatusMessage.studyStatusInvalidValue',
      defaultMessage: 'Invalid value',
    },
    [UploadSessionStatus.UploadSessionStatusToBeClosed]: {
      id: 'studyCard.uploadingStatusMessage.studyStatusInvalidValue',
      defaultMessage: 'Invalid value',
    },
  });
